import React from "react";
import Button from "@material-ui/core/Button";

export default class GieButton extends React.Component<any, any> {
  render() {
    const {
      children,
      style,
      styleClass,
      classes,
      onClick,
      disabled,
      ...p
    } = this.props;

    return (
      <Button onClick={onClick ? onClick : null} disabled={disabled} className={styleClass}
              style={style} classes={classes} {...p}>
        {children}
      </Button>
    );
  }
}
